import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-modal",
  style: {"width":"30vw"}
}
const _hoisted_2 = { class: "row-center" }
const _hoisted_3 = { class: "row-top mtop-04" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "row-center mtop-40 mleft-04" }
const _hoisted_6 = { class: "row-top mtop-04" }
const _hoisted_7 = ["src"]

import editMedicationPreference from './editMedicationPreference.vue'
import { ref, watch, computed, onBeforeUnmount, onMounted, nextTick } from 'vue'
import { useAppUserStore } from '@/stores/appUser'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import SharedService from "@/services/SharedService";
import { findMedicationPreference } from '@/functions/preferenceUtils'
import { splitSuggestions } from '@/functions/documentSuggestions'
import appuserapi from "@/api/appuserapi"
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'editMedicInfo',
  props: {
  sapConcept: { type: Object, default: null }
},
  emits: ['savePatientInfos', 'savePharmacyInfos'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore()
const currentEntryStore = useCurrentEntryStore()
const { t } = useI18n()

const props = __props
const emits = __emit

const patientInfosRef = ref(null)
const textPatientInfos = ref('')
const textPharmacyInfos = ref('')
const dropdPatient = ref(null)
const dropdPharmacy = ref(null)

const textFavorite = computed(() => {
  const suggestions = appUserStore.currentAppUserData.preferences.medicationSuggestions || []
  return findMedicationPreference(suggestions, currentEntryStore.poppedSapNewName, props.sapConcept?.definingSapExpression?.sctSubstanceKey)
})

const patientInfosPreference = ref('')
const pharmacyInfosPreference = ref('')
const autoUseFirstPatientInfo = ref(false)
const autoUseFirstPharmacyInfo = ref(false)

watch(
  textFavorite, (val) => {
    patientInfosPreference.value = val?.patientInfos || ''
    pharmacyInfosPreference.value = val?.pharmacyInfos || ''
    autoUseFirstPatientInfo.value = val?.autoUseFirstPatientInfo || false
    autoUseFirstPharmacyInfo.value = val?.autoUseFirstPharmacyInfo || false

    textPatientInfos.value = props.sapConcept?.patientInfo ?? ''
    textPharmacyInfos.value = props.sapConcept?.pharmacyInfo ?? ''
  },
  { immediate: true }
)

const patientInfosSuggestions = computed(() =>
  splitSuggestions(patientInfosPreference.value)
)
const pharmacyInfosSuggestions = computed(() =>
  splitSuggestions(pharmacyInfosPreference.value)
)

async function handleSavePatientInfosPreference(val) {
  await appuserapi.createPatientInfos(val, currentEntryStore.poppedSapExpr.expressionId, currentEntryStore.poppedSapNewName)
  await appUserStore.setCurrentAppUserData()
}

async function handleSavePharmacyInfosPreference(val) {
  await appuserapi.createPharmacyInfos(val, currentEntryStore.poppedSapExpr.expressionId, currentEntryStore.poppedSapNewName)
  await appUserStore.setCurrentAppUserData()
}

async function handleUpdateAutoUseFirstPatientInfo(val) {
  autoUseFirstPatientInfo.value = val
  await appuserapi.updateAutoUseFirstPatientInfo(val, currentEntryStore.poppedSapExpr.expressionId, currentEntryStore.poppedSapNewName)
  await appUserStore.setCurrentAppUserData()
}

async function handleUpdateAutoUseFirstPharmacyInfo(val) {
  autoUseFirstPharmacyInfo.value = val
  await appuserapi.updateAutoUseFirstPharmacyInfo(val, currentEntryStore.poppedSapExpr.expressionId, currentEntryStore.poppedSapNewName)
  await appUserStore.setCurrentAppUserData()
}

function suggestionAddFct(currentValue, suggItem) {
  return currentValue === '' ? suggItem : currentValue + '\n' + suggItem
}


function savePatientInfos(){
  const originalPatientInfos = props.sapConcept?.patientInfo || '';
  const originalPharmacyInfos = props.sapConcept?.pharmacyInfo || '';
  const basePayload = { conceptGroupId: props.sapConcept?.conceptGroupId };

  if (textPatientInfos.value !== originalPatientInfos) {
    emits('savePatientInfos', { ...basePayload, patientInfos: textPatientInfos.value });
  }
  if (textPharmacyInfos.value !== originalPharmacyInfos) {
    emits('savePharmacyInfos', { ...basePayload, pharmacyInfos: textPharmacyInfos.value });
  }
}

watch([dropdPatient, dropdPharmacy], ([newPatient, newPharmacy], [oldPatient, oldPharmacy]) => {
  if ((newPatient && !oldPatient) || (newPharmacy && !oldPharmacy)) {
    savePatientInfos();
  }
})

onMounted(() => {
  nextTick(() => patientInfosRef.value?.innerRef?.focus());
})

onBeforeUnmount(() => {
  savePatientInfos();
})

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.pharmacy.prescriptionInfo.patientInfos'),
        styles: "font-mBold",
        class: "mleft-02 mtop-03"
      }, null, 8, ["txt"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropdPatient.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropdPatient).value = $event)),
        openOn: "PatientInfosSettings",
        class: "mleft-08",
        combo: true
      }, {
        dropd: _withCtx(() => [
          _createVNode(editMedicationPreference, {
            title: _unref(t)('patient.pharmacy.prescriptionInfo.patientInfos'),
            value: patientInfosPreference.value,
            autoUseFirst: autoUseFirstPatientInfo.value,
            onUpdate: handleSavePatientInfosPreference,
            onUpdateAutoUseFirst: handleUpdateAutoUseFirstPatientInfo
          }, null, 8, ["title", "value", "autoUseFirst"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_es_button_icon, {
            icon: "gear",
            folder: "menuIcons",
            styles: "img-grey h-16 w-16",
            class: "pad-m"
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_inputBox, null, {
        default: _withCtx(() => [
          _createVNode(_component_inputAreaAuto2, {
            ref_key: "patientInfosRef",
            ref: patientInfosRef,
            modelValue: textPatientInfos.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textPatientInfos).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_buttonGroup, {
        class: "icon-clear",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (textPatientInfos.value = ''))
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
            class: "mtop-01 img-grey"
          }, null, 8, _hoisted_4)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_dbGroup, { class: "mtop-04 mleft-10" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientInfosSuggestions.value, (sugg, index) => {
          return (_openBlock(), _createBlock(_component_listGroup, {
            key: index,
            class: "pad-0 w-full gap-06",
            onClick: ($event: any) => (textPatientInfos.value = suggestionAddFct(textPatientInfos.value, sugg.text))
          }, {
            default: _withCtx(() => [
              (sugg.title)
                ? (_openBlock(), _createBlock(_component_text_item, {
                    key: 0,
                    txt: sugg.title,
                    class: "main-m max-w-suggestion"
                  }, null, 8, ["txt"]))
                : (_openBlock(), _createBlock(_component_text_item, {
                    key: 1,
                    txt: sugg.text,
                    class: "main-m max-w-suggestion"
                  }, null, 8, ["txt"]))
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.pharmacy.prescriptionInfo.pharmacyInfos'),
        styles: "font-mBold",
        class: "mleft-02 mtop-03"
      }, null, 8, ["txt"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropdPharmacy.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropdPharmacy).value = $event)),
        openOn: "PharmacyInfosSettings",
        class: "mleft-08",
        combo: true
      }, {
        dropd: _withCtx(() => [
          _createVNode(editMedicationPreference, {
            title: _unref(t)('patient.pharmacy.prescriptionInfo.pharmacyInfos'),
            value: pharmacyInfosPreference.value,
            autoUseFirst: autoUseFirstPharmacyInfo.value,
            onUpdate: handleSavePharmacyInfosPreference,
            onUpdateAutoUseFirst: handleUpdateAutoUseFirstPharmacyInfo
          }, null, 8, ["title", "value", "autoUseFirst"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_es_button_icon, {
            icon: "gear",
            folder: "menuIcons",
            styles: "img-grey h-16 w-16",
            class: "pad-m"
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_inputBox, null, {
        default: _withCtx(() => [
          _createVNode(_component_inputAreaAuto2, {
            modelValue: textPharmacyInfos.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((textPharmacyInfos).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_buttonGroup, {
        class: "icon-clear",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (textPharmacyInfos.value = ''))
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
            class: "mtop-01 img-grey"
          }, null, 8, _hoisted_7)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_dbGroup, { class: "mtop-04 mleft-10" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pharmacyInfosSuggestions.value, (sugg, index) => {
          return (_openBlock(), _createBlock(_component_listGroup, {
            key: index,
            class: "pad-0 w-full gap-06",
            onClick: ($event: any) => (textPharmacyInfos.value = suggestionAddFct(textPharmacyInfos.value, sugg.text))
          }, {
            default: _withCtx(() => [
              (sugg.title)
                ? (_openBlock(), _createBlock(_component_text_item, {
                    key: 0,
                    txt: sugg.title,
                    class: "main-m max-w-suggestion"
                  }, null, 8, ["txt"]))
                : (_openBlock(), _createBlock(_component_text_item, {
                    key: 1,
                    txt: sugg.text,
                    class: "main-m max-w-suggestion"
                  }, null, 8, ["txt"]))
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})